<template>
    <Card>
        <div class="flex justify-between h-full -mx-2">
            <div
                class="w-1/2 h-full px-2 border-r border-gray-500 border-solid"
            >
                <AmericanImport />
            </div>
            <div class="w-1/2 h-full px-2">
                <ExcelImport />
            </div>
        </div>
    </Card>
</template>

<script>
import ExcelImport from '@/components/measures/ExcelImport.vue';
import AmericanImport from '@/components/measures/AmericanImport.vue';
export default {
    name: 'MeasureCreate',
    components: {
        AmericanImport,
        ExcelImport,
    },
    data: () => ({
        measure: {

        },
    }),
};
</script>

<style></style>
